/* eslint-disable import/no-anonymous-default-export */
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from '@insticator/insticator-ui'

/* ++++++++++ --------------- EXPORT : COMMENTING CONFIGURATION ADVANCED SECTION - MESSAGE TO END-USERS : STYLES --------------- ++++++++++ */
export default theme => ({
  placeholdertext: {
    '& .commentbox': {
      display: 'flex',
      width: '100%',
      height: '100%',
      alignItems: 'flex-start',
      background: '#E7EAF7',
      borderRadius: pxToEm(8),
      padding: '16px',
      '& .commenttextarea': {
        width: '100%',
        paddingBottom: '24px',
        marginBottom: '8px',
        borderBottom: `3px solid #5A74DD`
      },
      '& h1': {
        fontWeight: 400
      },
      '& *[fill]:not(svg)': {
        fill: '#5566AA'
      },
      '& .button': {
        padding: '6px 10px',
        fontSize: '16px',
        width: '60px',
        borderRadius: pxToEm(4),
        fontWeight: 600,
        minHeight: '32px',
        maxHeight: '32px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#CCD1E6',
        color: '#7A87BC'
      }
    }
  }
});
